import { upload_file } from '@/apis/common';
import { getGlobalStore } from '@/store/global';
import { environment } from '@gaodun.com/gtools';
import moment from 'moment';
import { camelCase } from 'loadsh';
// @ts-ignore
import * as Sentry from '@sentry/react';

// 对象中的key转换为小驼峰
export const convertKeysToCamelCase = (obj: any) => {
    if (Array.isArray(obj)) {
        return obj.map(v => convertKeysToCamelCase(v));
    } else if (obj?.constructor === Object) {
        return Object.keys(obj).reduce((result, key) => {
            const camelCaseKey = camelCase(key);
            result[camelCaseKey] = convertKeysToCamelCase(obj[key]);
            return result;
        }, {});
    }
    return obj;
};

/**
 * @description 判断是否为IE浏览器，如果是，是IE几
/**
 * 判断是否为ie浏览器
 * @return {number | string}
 */
export const judgeIEVersion = (): number | 'edge' => {
    const userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
    const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1; // 判断是否IE<11浏览器
    const isEdge = userAgent.indexOf('Edge') > -1 && !isIE; // 判断是否IE的Edge浏览器
    const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
    if (isIE) {
        // eslint-disable-next-line prefer-regex-literals
        const reIE = new RegExp('MSIE (\\d+\\.\\d+);');
        reIE.test(userAgent);
        const fIEVersion = parseFloat(RegExp['$1']);
        if (fIEVersion === 7) {
            return 7;
        } else if (fIEVersion === 8) {
            return 8;
        } else if (fIEVersion === 9) {
            return 9;
        } else if (fIEVersion === 10) {
            return 10;
        }
        return 6; // IE版本<=7
    } else if (isEdge) {
        return 'edge'; // edge
    } else if (isIE11) {
        return 11; // IE11
    }
    return -1; // 不是ie浏览器
};

export function getLinkSearch(key: string) {
    const pairs = window.location.search.slice(1).split('&') || [];
    const result: any = {};
    pairs.forEach(function (pair: any) {
        if (pair && pair.indexOf('=') !== -1) {
            // eslint-disable-next-line no-param-reassign
            pair = pair.split('=');
            // 兼容写法
            const keyData: string = pair[0].toLocaleLowerCase();
            result[keyData] = decodeURIComponent(pair[1] || '');
            result[pair[0]] = decodeURIComponent(pair[1] || '');
        }
    });
    return result[key];
}

export const parseSearchString = (search: string): Record<string, string> => {
    if (!search) return {};
    let newSearch = search;
    if (search.startsWith('?')) {
        newSearch = search.substring(1);
    }
    const params = {};
    const pairs = newSearch.split('&');
    for (const pair of pairs) {
        const [key, value] = pair.split('=');
        params[key] = value;
    }
    return params;
};

// 下划线转换驼峰
export const toHump = (name: string) => {
    return name.replace(/_(\w)/g, function (all, letter) {
        return letter.toUpperCase();
    });
};

// 驼峰转换下划线
export const toLine = (name: string) => {
    return name.replace(/([A-Z])/g, '_$1').toLowerCase();
};

export const randomNumber = (upper: number, lower: number, frontier = false) => {
    return Math.floor(Math.random() * (upper - lower + Number(!frontier))) + lower;
};
export const getActiveENV = () => {
    return environment.getApiEnv();
};

// 将 秒数 转化成 hh:mm:ss
export const formatSecodes = (val: number) => {
    const duration = moment.duration(val, 'seconds'); // 创建duration对象

    const hours = Math.floor(duration.asHours());
    let time;

    if (hours === 0) {
        // 如果小时为0，只显示分钟和秒
        time = moment.utc(duration.asMilliseconds()).format('mm:ss');
    } else {
        // 如果小时不为0，显示小时、分钟和秒
        time = moment.utc(duration.asMilliseconds()).format('HH:mm:ss');
    }

    return time;
};

export const uploadFile = async (file: File) => {
    try {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('file_name', file.name);
        fd.append('item_name', 'luca');
        fd.append('file_type', 'file');
        const { result } = await upload_file(fd);
        return `https://simg01.gaodunwangxiao.com/${result}`;
    } catch (error) {
        return '';
    }
};

export const blobToFile = async (blobUrl, fileName) => {
    // 使用 fetch 获取 Blob 对象
    const response = await fetch(blobUrl);
    const blob = await response.blob();

    // 创建 File 对象
    const file = new File([blob], fileName, { type: blob.type });

    return file;
};

// 复制功能
export async function copyToClipboard(text: string) {
    try {
        await navigator.clipboard.writeText(text);
    } catch (error) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
        } catch (error) {}
        document.body.removeChild(textArea);
    }
}

export const previewPicture = (url: string) => {
    getGlobalStore()?.publish('PicturePreview', { url });
};

export const delay = (waitTime: number) => {
    return new Promise(resolve => setTimeout(resolve, waitTime));
};

export const delayExcuteCallback = (callback: () => void, waitTime: number) => {
    setTimeout(callback, waitTime);
};

export const exchangeArrayEle = <T>(arr: T[], index1: number, index2: number) => {
    const newArr = [...arr];
    const item = newArr[index1];
    newArr[index1] = newArr[index2];
    newArr[index2] = item;
    return newArr;
};

export const isDesktop = () => {
    const userAgent = navigator.userAgent;
    const isDesktop = /Macintosh|Windows|Linux/i.test(userAgent);
    const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
    const isSmallScreen = window.innerWidth <= 800;
    return isDesktop && !isMobile && !isSmallScreen;
};

export const stopBodyScroll = () => {
    document.body.style.overflow = 'hidden';
};

export const recoverBodyScroll = () => {
    document.body.style.overflow = 'auto';
};

// 浏览器兼容弹窗
export const initCompatibleModal = () => {
    const scriptUrl = `https://gd-file.gaodun.com/browser-modal/bundle.js?v=${Date.now()}`;
    const div = document.createElement('div');
    div.id = 'adapterView';
    document.body.append(div);
    const scriptTag = document.createElement('script');
    scriptTag.src = scriptUrl;
    scriptTag.id = 'adapterView';
    document.body.appendChild(scriptTag);
    scriptTag.onload = () => {
        (window as any).useCompatibilityModal();
    };
};

// JS错误上报
export const sentryInit = () => {
    try {
        Sentry.init({
            dsn: 'https://ed283549dc7e77c4980e29582a061002@sentry.gaodun.com/121',
            environment: process.env.CROSS_ENV,
            integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
            tracesSampleRate: 1.0,
            maxBreadcrumbs: 50,
            profilesSampleRate: 0.01,
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 0.01,
        });
    } catch (error) {
        console.log('Sentry初始化失败', error);
    }
};

export const getCookieValueByKey = (key: string) => {
    const tokenStr = (document.cookie || '').match(/Accesstoken=[\w\.]+/);
    if (!tokenStr) return '';
    return tokenStr[0].split('=')[1];
};
